export default "__VITE_ASSET__C3o9Ffs7__"